export const mainContentId = 'main-content';
export const mainContentTitleId = `${mainContentId}--title`;
